// extracted by mini-css-extract-plugin
export default {"Icon":"WsBAi8Uf","IconContainer":"mNiCx5QX"};